import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from '../styles/table.module.css'
import { toast } from 'react-toastify'
import StateContext from '../context/state/StateContext'
import UserContext from '../context/user/UserContext'
import Loading from '../components/Loading'
import axios from 'axios'
import UserTable from '../components/UserTable'
import { useNavigate } from 'react-router-dom'
import { IoSearch } from 'react-icons/io5'
import Fuse from 'fuse.js'

const Employees = () => {

    const { getEmployees, user, user_verified } = useContext(UserContext);
    const { token, employees, setEmployees, setLoading, setModal } = useContext(StateContext)
    const [verified, setVerified] = useState([]);
    const employee_id = employees && employees.map(item => { return item.id })
    const [drop, setDrop] = useState(Array(employees.length).fill(false));
    const [searchValue, setSearchValue] = useState("")
    const navigate = useNavigate()
    const searchInputRef = useRef(null);

    useEffect(() => {
        if(user && user.role == "admin") {
            getEmployees();
        } else {
            if(user_verified){
                navigate('/dashboard')
            } else {
                navigate('/dashboard')
            }
        }
    }, [])

    useEffect(() => {
        if (employees) {
            setVerified(employees.map(item => { return item.role }))
        }
    }, [employees])
    
    // pagination code herere 
    const [currentPage, setCurrentPage] = useState(1);
    const usersPerPage = 6;

    const employeesWithId = employees.map((employee, index) => ({
        ...employee,
        numericalId: index,
    }));

    // Calculate the current users to display
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentEmployees = employeesWithId.slice(indexOfFirstUser, indexOfLastUser);

    // Calculate total pages
    const totalPages = Math.ceil(employees.length / usersPerPage);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const previousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Next page handler
    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleSubmit = async () => {
        try {
            await setLoading({ open: true, text: 'Searching...' })
            
            const response = await axios.put(process.env.REACT_APP_API_URL + "api/auth/update",
                { verified: verified, user_id: employee_id, user_role: user.role },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': `${token}`
                    },
                })

            const json = response.data;
            if (json.success) {
                toast.success("Successfully Updated")
                console.log(json.update);
                // setEmployees(json.users)
            } else {
                console.log(json.error || json.message);
            }

        } catch (error) {
            console.log(error);
        } finally {
            setLoading({ open: false, text: '' })
        }
    }

    const handleSearch = (value) => {
        setSearchValue(value)
    }

    // Function to fetch employees (optionally with search)
    const fetchEmployees = async (search = "") => {
        try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "api/auth/getAllEmployees", {
            params: { search: search.trim() ? search : undefined },
            headers: {
                'Content-Type': 'application/json',
                'auth-token': `${token}`
            },

        });
        if (response.data.success) {
            setEmployees(response.data.users);
        }
        } catch (error) {
        console.error(error);
        }
    };

    // Handle form submit
    const handleSearchSubmit = (e) => {
        e.preventDefault();
        const value = searchValue.trim();
        fetchEmployees(value);
    };

    // new changes
    return (
        <>
            <Loading />
            <div className={styles.table_container}>
                <div className={styles.head}>
                    <h1>Our Employees</h1>
                    <div className={styles.total}>
                        <div className={styles.icon}>
                            <i class="fa-solid fa-users"></i>
                        </div>
                        <div>
                            <h5>Total No. of Employees</h5>
                            <span>{employees.length}</span>
                        </div>
                    </div>
                </div>
                <form onSubmit={handleSearchSubmit} className={`search active`}>
                    <input type="text" value={searchValue} ref={searchInputRef} onChange={(e) => { handleSearch(e.target.value) }} placeholder="Search..." />
                    <button data-placement="bottom" className="icon" type="submit">
                        <IoSearch  />
                    </button>
                </form>
                {employees && employees.length > 0 ? <>
                <div className="d-flex justify-content-end align-items-end w-100">
                    <button className='button2' onClick={handleSubmit}>Update</button>
                </div>
                <div className={styles.table_content}>
                    <table>
                        <tbody>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Username</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Created</th>
                                <th>Role</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>

                            {employees && currentEmployees.map((item, index) => {
                                return <UserTable index={index} item={item} users={employees} verified={verified} setVerified={setVerified} drop={drop} setDrop={setDrop} setUsers={setEmployees} />
                            })}
                        </tbody>
                    </table>
                </div></>:<h3>No any Employees</h3>}

                {employees.length >= "6" ? <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div className={styles.pagination}>
                        <button onClick={previousPage} disabled={currentPage === 1} className={`${styles.btn} ${currentPage === 1 ? styles.disabled : ''}`}>Previous</button>
                        {[...Array(totalPages)].map((_, index) => (
                            <button
                                key={index}
                                onClick={() => paginate(index + 1)}
                                className={`${styles.btn} ${currentPage === index + 1 ? styles.active : ''}`}
                            >
                                {index + 1}
                            </button>
                        ))}
                        <button onClick={nextPage} disabled={currentPage === totalPages} className={`${styles.btn} ${currentPage === totalPages ? styles.disabled : ''}`}>Next</button>
                    </div>
                </div> : null}
            </div>
        </>
    )
}

export default Employees
